import React, {useState} from 'react';
import {Navigate} from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import { getAuthToken, getCurrentRole } from '../../../../utils/auth';
import { canAccessClientPreview } from '../../../../utils/role-utils';
import Footer from "../../../organisms/footer/footer";
import ModalHacShowContact from "../../../organisms/role-hac/modal-hac-show-contact/modal-hac-show-contact";

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Experience from "../../../organisms/common/experiences/experience";

const HacExperience = () => {

  window.scroll(0, 0);

  const token = getAuthToken();
  const role = getCurrentRole(token);

  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      {token && (role === 'hac' || role === 'pmaGM' || role === 'pma' || role === 'retailerGM' || role === 'retailer' || canAccessClientPreview(role)) ? (
        <div className="App">
          <Header/>
          <main className="experience landing product">
{/*            {role === 'hac' && (
              <Wadsworth/>
            )}*/}
            <Experience></Experience>
          </main>
          <ModalHacShowContact
            open={openModal}
            handleClose={handleCloseModal}
            className="modal-contact"
          />
          <Footer/>
        </div>
      ) : (
        <Navigate to="/login"/>
      )}
    </>
  );
};

export default HacExperience;
